<template>
	<div>
		<el-button @click="changeType">切换图表</el-button>
		<div id="myChart" style="height:600px;width: 600px;"></div>
	</div>
</template>

<script>
export default {
	name: 'home',

	data () {
		return {
			type: true,
			dateNunber: [0, 1, 2, 3, 4, 5],
			dateTime: [ '直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎' ]
		}
	},
	created () {
	},
	mounted () {
		let _this = this
		let myChartsize = document.querySelector('#myChart')
		let echarts = this.$echarts.init(document.getElementById('myChart'))
		window.onresize = () => {
			_this.chartssize(myChartsize)
			echarts.resize()
		}
		if (this.type) {
			this.drawLine()
		} else {
			this.drawLine1()
		}
	},
	methods: {
		changeType () {
			this.type = !this.type
			if (this.type) {
				this.drawLine()
			} else {
				this.drawLine1()
			}
		},
		drawLine () {
			var echarts = require('echarts')
			let myChart = this.$echarts.init(document.getElementById('myChart'))
			var that = this
			let option = {
				backgroundColor: '#fff',
				title: {
					text: '我是折线图',
					left: 'center',
					textStyle: {
						color: '#000',
						fontSize: 16
					}
				},
				grid: {
					top: '17%',
					left: '2%',
					right: '5%',
					bottom: '10%',
					containLabel: true
				},
				toolbox: {
					show: true,
					feature: {
						mark: { show: true },
						dataView: { show: true, readOnly: true },
						magicType: {
							show: true,
							type: ['pie', 'funnel'],
							option: {
								funnel: {
									x: '25%',
									width: '50%',
									funnelAlign: 'left',
									max: 1548
								}
							}
						},
						restore: { show: true },
						saveAsImage: { show: true }
					}
				},
				tooltip: {
					show: true,
					trigger: 'axis',
					formatter: function (params) {
						var htmlStr = '<div>'
						htmlStr += params[0].name + '<br/>' // x轴的名称
						htmlStr += params[0].value + (that.value === '2' ? '%' : '')
						htmlStr += '</div>'
						return htmlStr
					}
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: this.dateTime,
					axisLabel: {
						margin: 15,
						color: '#333'
					},
					axisLine: {
						show: false
					},
					axisTick: {
						show: true,
						length: 0,
						lineStyle: {
							color: '#000'
						}
					},
					splitLine: {
						show: true,
						lineStyle: {
							color: '#ECECEC'
						}
					}
				},
				yAxis: [{
					type: 'value',
					position: 'left',
					axisLabel: {
						margin: 20,
						color: '#333'
					},
					axisTick: {
						show: true,
						length: 0,
						lineStyle: {
							color: '#000'
						}
					},
					splitLine: {
						show: true,
						lineStyle: {
							color: '#ECECEC'
						}
					},
					axisLine: {
						lineStyle: {
							color: '#ECECEC',
							width: 1
						}
					}
				}],
				series: [{
					name: '',
					type: 'line',
					smooth: true,
					showAllSymbol: true,
					symbol: 'circle',
					symbolSize: 4,
					lineStyle: {
						normal: {
							color: '#28B3E3'
						}
					},
					label: {
						show: false,
						position: 'top',
						textStyle: {
							color: 'grey'
						}
					},
					itemStyle: {
						color: '#28B3E3',
						borderColor: '#28B3E3',
						borderWidth: 1
					},
					tooltip: {
						show: true,
						trigger: 'axis'
					},
					areaStyle: {
						normal: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#eb64fb'
							}, {
								offset: 1,
								color: '#3fbbff0d'
							}], false)
						}
					},
					data: this.dateNunber
				}]
			}
			myChart.setOption(option, true)
		},
		drawLine1 () {
			let myChart = this.$echarts.init(document.getElementById('myChart'))
			let option = {
				backgroundColor: '#fff',
				title: {
					text: '我是饼图',
					x: 'center'
				},
				toolbox: {
					show: true,
					feature: {
						mark: { show: true },
						dataView: { show: true, readOnly: true },
						magicType: {
							show: true,
							type: ['pie', 'funnel'],
							option: {
								funnel: {
									x: '25%',
									width: '50%',
									funnelAlign: 'left',
									max: 1548
								}
							}
						},
						restore: { show: true },
						saveAsImage: { show: true }
					}
				},
				calculable: true,
				series: [
					{
						name: '访问来源',
						type: 'pie',
						radius: '55%',
						center: ['50%', '60%'],
						data: [
							{ value: 335, name: '直接访问' },
							{ value: 30, name: '邮件营销' },
							{ value: 234, name: '联盟广告' },
							{ value: 135, name: '视频广告' },
							{ value: 1548, name: '搜索引擎' }
						]
					}
				]
			}
			myChart.setOption(option, true)
		},
		chartssize (charts) {
			charts.style.width = '600px'
			charts.style.height = '600px'
		},
		getStyle (el, name) {
			if (window.getComputedStyle) {
				return window.getComputedStyle(el, null)
			} else {
				return el.currentStyle
			}
		}
	}
}
</script>
<style lang="stylus" scoped>
</style>
